export const CHOCO_DATETIME_OBJECT = Symbol('CHOCO_DATETIME_OBJECT');
export const CHOCO_DATETIME_FORMAT_OBJECT = Symbol('CHOCO_DATETIME_FORMAT_OBJECT');
export const CHOCO_CALENDAR_OBJECT = Symbol('CHOCO_CALENDAR_OBJECT');
